class IsabellaRelatedProducts extends HTMLElement {
    constructor() {
        super();
        this.type = this.getAttribute('type');
        this.productId = this.getAttribute('product-id');
        this.variantId = this.getAttribute('variant-id');
        this.getProductHtml();
    }
    
    async getProductHtml(){
        const request = await fetch(`${e4.settings.ecom.related.url}?relatedProductType=${this.type}&productId=${this.productId}&variantId=${this.variantId}`);

        const container = document.createElement('div');
        container.innerHTML = await request.text();

        // Replace the custom element with the parsed HTML content
        this.replaceWith(...container.childNodes);
    }
}

customElements.define( 'related-products', IsabellaRelatedProducts );